import { planTypes } from "@/common/constants";
import { pageConfig } from "@/common/service/page-config";
import modulesmap from './auto-scan';
import { getPlanTypeByCategory } from "@/common/service/parse";

const moduleKeys = Object.values(modulesmap).map(x => x.key);

const type = pageConfig?.editConfig?.planType;
const baseType = getPlanTypeByCategory(pageConfig?.plan);
// const flow = pageConfig?.type;

const prioritize = (sorts = defSorts, priorities = [], removes = []) => {
    priorities = priorities.filter(x => planTypes[x]);
    return [...new Set([...priorities, ...sorts])].filter(x => !removes.includes(x));
};

const EVENTS_SESSIONS = [
    planTypes.EVENT_SAAS,
    planTypes.EVENT_SAAS_CORE,
    planTypes.ADDITIONAL_HOST,
    planTypes.ADDITIONAL_CO_EDITOR,
];

const PHONE = [
    planTypes.ZOOM_PHONE,
    planTypes.ZOOM_PHONE$ZPA,
    planTypes.ZOOM_PHONE$ZPI
];

const defSorts = prioritize(planTypes.map(moduleKeys), [
    planTypes.ZOOM_MEETING,
    planTypes.ZOOM_ONE_BUNDLE,
    planTypes.ZONE_PRO_PLUS,
    planTypes.MASTER_CLASS,
    ...EVENTS_SESSIONS,
    ...PHONE,
    planTypes.ZOOM_SCHEDULER,
    planTypes.CMR,
    planTypes.LARGE_MEETING,
    planTypes.TRANSLATION_CAPTIONS,
    planTypes.WEBINAR,
    planTypes.EVENT_SERVICES,
    planTypes.ZOOM_WHITEBOARD,
    planTypes.ZOOM_ROOMS,
    planTypes.TOLLFREE,
]);

// this is for sort & filter
const priorities = [
    {
        for: () => pageConfig.isWinback && (pageConfig.init_categories && pageConfig.init_categories.length),
        sorts: prioritize(
            (pageConfig.init_categories || '').split(';').map(c => getPlanTypeByCategory(c)).filter(Boolean),
            defSorts
        ),
    },
    {
      for: () => type === planTypes.WEBINAR,
      sorts: prioritize(defSorts, [
        planTypes.WEBINAR,
        planTypes.EVENT_SERVICES,
        planTypes.ZOOM_MEETING,
        planTypes.ZOOM_ONE_BUNDLE,
        planTypes.ZONE_PRO_PLUS,
      ]),
    },
    {
        for: () => type === planTypes.ZOOM_MEETING,
        sorts: prioritize(defSorts, [
            planTypes.MASTER_CLASS,
            planTypes.ZOOM_SCHEDULER,
            planTypes.LARGE_MEETING,
            planTypes.CMR,
        ]),
    }, {
        for: () => type === planTypes.TOLLFREE && baseType !== planTypes.VIDEO_SDK,
        sorts: [
            planTypes.ZOOM_MEETING,
            planTypes.ZOOM_SCHEDULER,
            planTypes.CMR,
            planTypes.WEBINAR,
            planTypes.TOLLFREE$DID,
        ],
    }, {
        for: () => type === planTypes.TOLLFREE && baseType === planTypes.VIDEO_SDK,
        sorts: [
            planTypes.VIDEO_SDK,
            planTypes.LDKCMR
        ],
    }, {
      for: () => type === planTypes.ZONE_PRO_PLUS,
      sorts: [
        planTypes.TRANSLATION_CAPTIONS,
        planTypes.CMR,
        planTypes.LARGE_MEETING,
        planTypes.WEBINAR,
        planTypes.EVENT_SERVICES,
        planTypes.ZOOM_PHONE$ZPI,
        planTypes.ZOOM_PHONE$ZPA,
        planTypes.ZOOM_WHITEBOARD,
        planTypes.TOLLFREE,
        planTypes.ZOOM_SCHEDULER,
        planTypes.ZOOM_ONE_BUNDLE, // for pro plus upgrade to biz plus
        planTypes.ZOOM_PHONE, // For campaign link validate/verify api param sort (pro plus calling plan needs to be added in front of pbx)
      ],
    }, {
        for: () => true,
        sorts: defSorts,
    }
];

const sorts = priorities.find(x => x.for())?.sorts ?? [];

export default prioritize(sorts, [type]); // always prioritize target plans
